import React, { useCallback, useEffect, useState, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Slide1 } from './Slide1';
import { Slide2 } from './Slide2';
import { Slide3 } from './Slide3';
import { Slide4 } from './Slide4';
import { Slide5 } from './Slide5';
import { SlideConfigurator } from './SlideConfigurator';
import { Slide6 } from './Slide6';
const slides = [Slide1, Slide2, Slide3, Slide4, Slide5, SlideConfigurator, Slide6];
export function Presentation() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [direction, setDirection] = useState(0);
  const paginate = useCallback((newDirection: number) => {
    setDirection(newDirection);
    setCurrentSlide(prev => {
      let next = prev + newDirection;
      if (next < 0) next = 0;
      if (next >= slides.length) next = slides.length - 1;
      return next;
    });
  }, []);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight' || e.key === 'Space') {
        paginate(1);
      } else if (e.key === 'ArrowLeft') {
        paginate(-1);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [paginate]);
  const variants = {
    enter: (direction: number) => {
      return {
        x: direction > 0 ? 1000 : -1000,
        opacity: 0
      };
    },
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => {
      return {
        zIndex: 0,
        x: direction < 0 ? 1000 : -1000,
        opacity: 0
      };
    }
  };
  const CurrentSlideComponent = slides[currentSlide];
  return <div className="slide-container bg-bg-white text-text-main" data-id="element-1">
      <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-2">
        <motion.div key={currentSlide} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
        x: {
          type: 'spring',
          stiffness: 300,
          damping: 30
        },
        opacity: {
          duration: 0.2
        }
      }} className="absolute inset-0 w-full h-full" data-id="element-3">
          <CurrentSlideComponent data-id="element-4" />
        </motion.div>
      </AnimatePresence>

      {/* Navigation Indicators */}
      <div className="absolute bottom-8 left-0 right-0 flex justify-center items-center space-x-3 z-50" data-id="element-5">
        {slides.map((_, index) => <button key={index} onClick={() => {
        setDirection(index > currentSlide ? 1 : -1);
        setCurrentSlide(index);
      }} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${index === currentSlide ? 'bg-roche-red w-8' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-6" />)}
      </div>

      {/* Slide Counter */}
      <div className="absolute bottom-8 right-12 text-text-muted font-medium text-sm z-50" data-id="element-7">
        {currentSlide + 1} / {slides.length}
      </div>
    </div>;
}